module.exports = __webpack_public_path__ + "img/app.091d331b.png";